import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { formatDate } from "../../../Components/Common/FormatDate";
import { Link, useNavigate, useParams } from "react-router-dom";
import FranchiseEnquiryService from "../../../services/KangarooServices/FranchiseEnquiryService";
import { useFormik } from "formik";
import toast from "react-hot-toast";

const FranchiseForm = () => {
  const { id } = useParams();
  const [destinationData, setDestinationData] = useState([]);
  const [detailData, setDetailData] = useState();
  const navigate = useNavigate();
  const fetchDestination = async () => {
    try {
      const response = await FranchiseEnquiryService.getList();
      setDestinationData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchDestination();
  }, []);
  const fetchDetail = async () => {
    try {
      const response = await FranchiseEnquiryService.getDetail(id);
      setDetailData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchDetail();
  }, [id]);

  const formik = useFormik({
    initialValues: {
      id: detailData?.id,
      fullName: detailData?.fullName || "",
      email: detailData?.email || "",
      phone: detailData?.phone || "",
      phoneCountryCode: detailData?.phoneCountryCode || "",
      prefreredLocation: detailData?.prefreredLocation || "",
      message: detailData?.message || "",
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        if (id) {
          const response = await FranchiseEnquiryService.update(id, values);
          toast.success("Student forms updated.");
        } else {
          const response = await FranchiseEnquiryService.create(values);
          toast.success("Student forms created.");
        }
        navigate("/franchise-enquiry");
      } catch (error) {
        console.log(error);
      }
    },
  });

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb
          title="Franchise Enquiry Form"
          pageTitle="Franchise Enquiry"
          breadcrumbItems={[
            { title: "Back to List", link: "/franchise-enquiry" },
          ]}
        />
        <Form onSubmit={formik.handleSubmit}>
          <Row>
            <div className="hstack gap-2 justify-content-end mb-3">
              <Button color="success" type="submit">
                {id ? "Update" : "Add"} Form
              </Button>
              <Button
                color="danger"
                type="button"
                onClick={() => navigate("/franchise-enquiry")}
              >
                Cancel
              </Button>
            </div>
          </Row>
          <Row>
            {/* Left Card */}

            <Card className="">
              <CardBody>
                <Row>
                  <Col lg={6}>
                    <FormGroup className="mb-3">
                      <Label>Full Name</Label>
                      <Input
                        name="fullName"
                        value={formik.values.fullName}
                        onChange={formik.handleChange}
                        placeholder="Enter full name"
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <FormGroup className="mb-3">
                      <Label>Email</Label>
                      <Input
                        type="email"
                        name="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        placeholder="Enter email address"
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <FormGroup className="mb-3">
                      <Label>Country Code </Label>
                      <Input
                        name="phoneCountryCode"
                        value={formik.values.phoneCountryCode}
                        onChange={formik.handleChange}
                        placeholder="Enter country code"
                      />
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <FormGroup className="mb-3">
                      <Label>Phone</Label>
                      <Input
                        type="text"
                        name="phone"
                        value={formik.values.phone}
                        onChange={formik.handleChange}
                        placeholder="Enter phone number"
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <FormGroup className="mb-3">
                      <Label>Prefrered Location</Label>
                      <Input
                        name="prefreredLocation"
                        value={formik.values.prefreredLocation}
                        onChange={formik.handleChange}
                        placeholder="Enter prefrered location"
                      />
                    </FormGroup>
                  </Col>
                  <Col lg={12}>
                    <FormGroup className="mb-3">
                      <Label>Message</Label>
                      <Input
                        name="message"
                        type="textarea"
                        rows={6}
                        value={formik.values.message}
                        onChange={formik.handleChange}
                        placeholder="Enter message"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {/* Right Card */}
          </Row>
        </Form>
      </div>
    </Container>
  );
};

export default FranchiseForm;
